<template>
  <div id="info">
    <h1>{{ $t('info') }}</h1>
    <dl :class="{en: $i18n.locale === 'en'}">
      <dt>{{ $t('menu.dishes') }}</dt>
      <dd>{{ $t('menu.omakase') }}</dd>
      <dd>
        <table class="menu" :class="{en: $i18n.locale === 'en'}">
          <tbody>
            <tr>
              <th>{{ $t('menu.lunch') }}</th>
              <td v-html="$t('menu.lunchPrice')" />
            </tr>
            <tr>
              <th>{{ $t('menu.dinner') }}</th>
              <td v-html="$t('menu.dinnerPrice')" />
            </tr>
          </tbody>
        </table>
      </dd>
      <dd class="addition" v-html="$t('menu.dishesAddition')" />

      <dt>{{ $t('menu.beverage') }}</dt>
      <dd>
        <table class="menu beverage" :class="{en: $i18n.locale === 'en'}">
          <tbody>
            <tr>
              <th >{{ $t('menu.beerTitle') }}</th>
              <td v-html="$t('menu.beer')" />
            </tr>
            <tr>
              <th>{{ $t('menu.sakeTitle') }}</th>
              <td v-html="$t('menu.sake')" />
            </tr>
            <tr>
              <th>{{ $t('menu.shochuTitle') }}</th>
              <td v-html="$t('menu.shochu')" />
            </tr>
            <tr>
              <th>{{ $t('menu.whiskeyTitle') }}</th>
              <td v-html="$t('menu.whiskey')" />
            </tr>
            <tr>
              <th>{{ $t('menu.wineTitle') }}</th>
              <td v-html="$t('menu.wine')" />
            </tr>
            <tr>
              <th>{{ $t('menu.softDrinkTitle') }}</th>
              <td v-html="$t('menu.softDrink')" />
            </tr>
          </tbody>
        </table>
      </dd>
      <dd class="addition">
        {{ $t('menu.beverageAddition') }}
      </dd>

      <dt>{{ $t('menu.delivery') }}</dt>
      <dd v-html="$t('menu.catering')" />

      <dt>{{ $t('menu.takeoutTitle') }}</dt>
      <dd v-html="$t('menu.takeout')" />
      <dd class="addition">
        {{ $t('menu.takeoutAddition') }}
      </dd>

      <dt>{{ $t('menu.sheetsTitle') }}</dt>
      <dd>
        <table class="menu" :class="{en: $i18n.locale === 'en'}">
          <tbody>
            <tr>
              <th v-html="$t('menu.tearoom')"></th>
              <td>4{{ $t('menu.persons') }}</td>
            </tr>
            <tr>
              <th v-html="$t('menu.hinoki')"></th>
              <td>10{{ $t('menu.persons') }}</td>
            </tr>
            <tr>
              <th v-html="$t('menu.kuri')"></th>
              <td>5{{ $t('menu.persons') }}</td>
            </tr>
            <tr>
              <th v-html="$t('menu.counter')"></th>
              <td>6{{ $t('menu.persons') }}</td>
            </tr>
            <tr v-if="$i18n.locale === 'en'">
              <td colspan="2">Digging kotatsu seats for <i>Chashitsu</i> and Chestnut room</td>
            </tr>
          </tbody>
        </table>
      </dd>

      <dt class="cancel-policy">{{ $t('menu.cancelPolicyTitle') }}</dt>
      <dd>
        {{ $t('menu.cancelPolicy') }}<br/><br/>
      </dd>

      <dt>{{ $t('menu.book') }}</dt>
      <dd v-html="$t('menu.bookTitle')" />
      <dd class="addition">
        {{ $t('menu.bookAddition') }}
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
#info {
  margin-bottom: 120px;
}

dl {
  font-size: 12px;

  dd {
    margin-left: 16px;
    letter-spacing: 0;
    line-height: 1.6;
    .book {
      margin-left: -0.5em;
    }
  }
  &.en dt {
    font-size: 14px;
  }
  dt {
    margin: 48px 0 11px 0;
  }
  dt:first-child {
    margin: 24px 0 11px 0;
  }
  .menu {
    tr {
      line-height: 1.35;
    }
    th {
      text-align: left;
      min-width: 80px;
      padding: 0 10px 0 0;
    }
    th, td {
      vertical-align: top;
    }
  }
  .addition {
    margin-top: 5px;
    font-size: 8px;
  }
}

@media (min-width: $mobile-vw) {
  #info {
    margin-top: 33px;
  }
  #info h1 {
    margin-bottom: 70px;
  }

  dl {
    font-size: 16px;
    letter-spacing: -0.02em;
    dd {
      margin-left: 17px;
      .book, .book-en {
        display: inline-block;
      }
    }
    &.en dt {
      font-size: 18px;
    }
    dt {
      margin: 90px 0 13px 0;
    }
    dt:first-child {
      margin: 45px 0 13px 0;
    }
    dt.cancel-policy {
      margin-top: 52px;
    }
    .menu {
      tr {
        line-height: 1.45;
      }
      th {
        width: 123px;
      }
      &.en {
        tr, th {
          line-height: 1.6;
        }
        }
        th {
          width: 180px;
        }
      }
    .addition {
      font-size: 10px;
      margin-top: 3px;
      line-height: 1.7;
    }
  }
  #info {
    margin-bottom: 200px;
  }
}
</style>